import {
  Base64EncodingType,
  DpInferenceConfig,
  DpModelType,
  OcrModeType,
  OutputFormatType,
} from "./dpInferenceConfig";
import { OcrInferenceConfig, OcrModelType } from "./ocrInferenceConfig";
import { DEFAULT_DP_INFERENCE_CONFIG } from "../constants/DpInferenceConfig";
import { DEFAULT_OCR_INFERENCE_CONFIG } from "../constants/OcrInferenceConfig";

export interface ExtractorInferenceConfigParams {
  modelPath: "extraction";
}

// API 요청용 snake_case 인터페이스
export interface DPInferenceConfigParams {
  model?: DpModelType;
  ocr?: OcrModeType;
  coordinates?: boolean;
  chart_recognition?: boolean;
  output_formats?: OutputFormatType[];
  base64_encoding?: Base64EncodingType[];
}

export interface OcrInferenceConfigParams {
  model?: OcrModelType;
}

// 순환 참조 방지 위해 해당 파일에 위치
// 변환 유틸리티 함수 : camelCase -> snake_case
export const convertDPInferenceConfigToParams = (
  config: DpInferenceConfig,
): DPInferenceConfigParams => {
  const { chartRecognition, outputFormats, base64Encoding, ...rest } = config;

  return {
    ...rest,
    chart_recognition: chartRecognition,
    output_formats: outputFormats,
    base64_encoding: base64Encoding,
  };
};

export const convertOcrInferenceConfigToParams = (
  config: OcrInferenceConfig,
): OcrInferenceConfigParams => {
  const { ...rest } = config;

  return {
    ...rest,
  };
};

export const DEFAULT_EXTRACTOR_INFERENCE_CONFIG_PARAMS: ExtractorInferenceConfigParams =
  {
    modelPath: "extraction",
  };

// API 요청 시 사용할 snake_case 기본값
export const DEFAULT_DP_INFERENCE_CONFIG_PARAMS =
  convertDPInferenceConfigToParams(DEFAULT_DP_INFERENCE_CONFIG);

export const DEFAULT_OCR_INFERENCE_CONFIG_PARAMS =
  convertOcrInferenceConfigToParams(DEFAULT_OCR_INFERENCE_CONFIG);
